import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	rovoAwarenessMessage: {
		id: 'ai-awareness.rovoAwarenessMessage',
		defaultMessage: 'Summary by Rovo',
		description: 'Rovo awareness message',
	},
});
